/**
 * Model-year revisions (MP1/MP2) exist only for VW (`V`) and VWN (`N`).
 * The value is the renderer's literal (`MP1` / `MP2`); an empty string means
 * "no revision".
 */
export const MODEL_REVISIONS = ['MP1', 'MP2'] as const;

export type ModelRevision = (typeof MODEL_REVISIONS)[number];

const MODEL_REVISION_BRANDS: readonly string[] = ['V', 'N'];

/**
 * Trims and upper-cases a string value. Anything that is not a non-empty
 * string yields ''. Unknown revisions (e.g. 'MP3') are passed through so the
 * session stays lenient.
 */
export function normalizeModelRevision(value: unknown): string {
  if (typeof value !== 'string') return '';
  return value.trim().toUpperCase();
}

/** True only for VW (`V`) and VWN (`N`). */
export function supportsModelRevision(brand?: string): boolean {
  return brand !== undefined && MODEL_REVISION_BRANDS.includes(brand);
}

/** Dropdown options: '' plus MP1/MP2 for VW/VWN, otherwise none. */
export function getModelRevisionOptions(brand?: string): string[] {
  return supportsModelRevision(brand) ? ['', ...MODEL_REVISIONS] : [];
}
